/* VR 2026-10-03 — Globo add-on prices show the running sale.
   The option prices ("+ €189,90") are plain product prices. AUTUMN SALE is an
   app discount that Shopify only applies in the cart, so the configurator
   showed the full price while the customer pays less.

   No percentage is hard-coded: the script asks Shopify itself. It posts the
   add-on variants to /cart/add.js WITHOUT cookies, which the shop answers from
   a throwaway server-side cart — real prices incl. every active discount, and
   the customer's own cart is never touched. Answer is cached per session.
   If nothing is discounted, the page stays exactly as the app rendered it. */
(function () {
  var CACHE_KEY = 'vr_gpo_sale_v1';
  var CACHE_MS = 10 * 60 * 1000; // the shop may start or stop a sale any minute
  var prices = null;

  function ids() {
    var out = [];
    document.querySelectorAll('[gpo-data-variant-id]').forEach(function (el) {
      var id = el.getAttribute('gpo-data-variant-id');
      if (id && out.indexOf(id) === -1) out.push(id);
    });
    return out;
  }

  /* Second case: the add-on is a normal product that simply sits on sale
     (compare-at price). No cart discount is involved, so the probe sees
     nothing — the saving comes from the product itself. */
  function addCompareAtPrices(map) {
    var handles = {};
    document.querySelectorAll('[gpo-data-variant-id][gpo-data-product-handle]').forEach(function (el) {
      var id = el.getAttribute('gpo-data-variant-id');
      if (map[id]) return;
      var handle = el.getAttribute('gpo-data-product-handle');
      if (!handles[handle]) handles[handle] = [];
      handles[handle].push(id);
    });
    var names = Object.keys(handles);
    if (!names.length) return Promise.resolve(map);

    return Promise.all(names.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product) return;
          product.variants.forEach(function (variant) {
            if (handles[handle].indexOf(String(variant.id)) === -1) return;
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              map[variant.id] = { original: variant.compare_at_price, final: variant.price, title: '' };
            }
          });
        })
        .catch(function () {});
    })).then(function () { return map; });
  }

  function fetchPrices(list) {
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null'); } catch (e) {}
    if (cached && cached.key === list.join(',') && (Date.now() - (cached.at || 0)) < CACHE_MS) {
      return Promise.resolve(cached.map);
    }

    /* vr=probe marks this as a price lookup: vr-cart-autoopen.js ignores it,
       otherwise the drawer would pop open on every product page. */
    return fetch('/cart/add.js?vr=probe', {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: list.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var map = {};
        if (!data || !data.items) return addCompareAtPrices(map).then(function (m) {
          try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ key: list.join(','), map: m, at: Date.now() })); } catch (e) {}
          return m;
        });
        data.items.forEach(function (item) {
          if (item.final_price < item.original_price) {
            var alloc = (item.line_level_discount_allocations || [])[0];
            map[item.variant_id] = {
              original: item.original_price,
              final: item.final_price,
              title: alloc && alloc.discount_application ? alloc.discount_application.title : ''
            };
          }
        });
        return addCompareAtPrices(map);
      })
      .catch(function () { return addCompareAtPrices({}); })
      .then(function (map) {
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ key: list.join(','), map: map, at: Date.now() })); } catch (e) {}
        return map;
      });
  }

  /* Rebuild the amount in the shop's own format: keep whatever sits around the
     digits ("(+ €", ")") and the separators the theme printed. */
  function money(sample, cents) {
    var m = String(sample).match(/^(\D*)([\d.,\s]+)(\D*)$/);
    if (!m) return null;
    var digits = m[2].trim();
    var dec = digits.lastIndexOf(',') > digits.lastIndexOf('.') ? ',' : '.';
    var thousands = dec === ',' ? '.' : ',';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return m[1] + whole + dec + parts[1] + m[3];
  }

  function toCents(text) {
    var m = String(text).match(/([\d.,\s]+)/);
    if (!m) return null;
    var digits = m[1].replace(/\s/g, '');
    var dec = digits.lastIndexOf(',') > digits.lastIndexOf('.') ? ',' : '.';
    var thousands = dec === ',' ? '.' : ',';
    var clean = digits.split(thousands).join('').replace(dec, '.');
    var value = parseFloat(clean);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  function swap(node, sample, originalCents, finalCents) {
    var open = (sample.match(/^\(\s*\+?\s*/) || [''])[0];
    var close = /\)\s*$/.test(sample) ? ')' : '';
    var inner = sample.slice(open.length, sample.length - close.length);
    var was = money(inner, originalCents);
    var now = money(inner, finalCents);
    if (!was || !now) return false;
    node.textContent = '';
    if (open) node.appendChild(document.createTextNode(open));
    var struck = document.createElement('s');
    struck.className = 'vr-gpo-was';
    struck.textContent = was;
    node.appendChild(struck);
    node.appendChild(document.createTextNode(' '));
    var sale = document.createElement('span');
    sale.className = 'vr-gpo-now';
    sale.textContent = now;
    node.appendChild(sale);
    if (close) node.appendChild(document.createTextNode(close));
    return true;
  }

  /* Which value of a field is currently chosen — dropdown, swatch or radio. */
  function selectedInput(field) {
    var inputs = field.querySelectorAll('[gpo-data-variant-id]');
    var shown = field.querySelector('.gpo-selected-values');
    var button = field.querySelector('.dropdown-button');
    var texts = [shown && shown.textContent, button && button.textContent]
      .filter(Boolean).map(function (t) { return t.trim().toLowerCase(); });
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.checked) return input;
      var value = (input.value || '').trim().toLowerCase();
      if (value && texts.indexOf(value) !== -1) return input;
    }
    return null;
  }

  /* The field header ("Sprocket? (+ €44,95)") and Globo's own total still show
     the undiscounted amounts — both follow the current selection. */
  function headersAndTotal() {
    var saved = 0;
    document.querySelectorAll('.gpo-element').forEach(function (field) {
      var input = selectedInput(field);
      var info = input && prices[input.getAttribute('gpo-data-variant-id')];
      if (!info) return;
      saved += info.original - info.final;
      var head = field.querySelector('label.gpo-label .addOn');
      if (head && !head.querySelector('.vr-gpo-now')) swap(head, head.textContent.trim(), info.original, info.final);
    });

    var total = document.querySelector('.gpo-total-text .money');
    if (!total) return;

    var struck = total.querySelector('.vr-gpo-was');
    var full = toCents(struck ? struck.textContent : total.textContent);
    if (full === null) return;

    if (!saved) {
      // Nothing discounted selected any more: let Globo's own number stand.
      if (struck) total.textContent = struck.textContent;
      return;
    }

    /* No memo flag here: Globo rewrites this number on every change, including
       options that are not on sale. Compare against what is on screen right
       now, otherwise the sum silently stays at the undiscounted value. */
    var sample = struck ? struck.textContent.trim() : total.textContent.trim();
    var wantWas = money(sample, full);
    var wantNow = money(sample, full - saved);
    var shownNow = total.querySelector('.vr-gpo-now');
    if (struck && shownNow && struck.textContent === wantWas && shownNow.textContent === wantNow) return;
    swap(total, sample, full, full - saved);
  }

  function apply() {
    if (!prices) return;
    document.querySelectorAll('[gpo-data-variant-id]').forEach(function (input) {
      var info = prices[input.getAttribute('gpo-data-variant-id')];
      if (!info) return;
      var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
      if (!label) label = input.closest('label') || (input.nextElementSibling && input.nextElementSibling.matches('label') ? input.nextElementSibling : null);
      if (!label) return;
      var addOn = label.querySelector('.addOn');
      if (!addOn || addOn.dataset.vrSale === String(info.final)) return;
      var text = addOn.textContent.trim();
      /* "(+ €189,90)" → brackets off, amount reformatted, brackets back on, so
         the currency symbol stays glued to each amount. */
      var open = (text.match(/^\(\s*\+?\s*/) || [''])[0];
      var close = /\)\s*$/.test(text) ? ')' : '';
      var inner = text.slice(open.length, text.length - close.length);
      var now = money(inner, info.final);
      var was = money(inner, info.original);
      if (!now || !was) return;
      addOn.dataset.vrSale = String(info.final);
      addOn.textContent = '';
      if (open) addOn.appendChild(document.createTextNode(open));
      var struck = document.createElement('s');
      struck.className = 'vr-gpo-was';
      struck.textContent = was;
      addOn.appendChild(struck);
      addOn.appendChild(document.createTextNode(' '));
      var sale = document.createElement('span');
      sale.className = 'vr-gpo-now';
      sale.textContent = now;
      addOn.appendChild(sale);
      if (close) addOn.appendChild(document.createTextNode(close));
      if (info.title) addOn.setAttribute('title', info.title);
    });
    headersAndTotal();
  }

  function start() {
    var list = ids();
    if (!list.length) return;
    fetchPrices(list).then(function (map) {
      if (!map || !Object.keys(map).length) return;
      prices = map;
      apply();
      var t;
      var again = function () { clearTimeout(t); t = setTimeout(apply, 120); };
      /* characterData matters: Globo rewrites its total by changing the text
         node itself, which a childList-only observer never sees — the total
         then kept the undiscounted sum until a discounted field was touched. */
      new MutationObserver(again).observe(document.body, {
        childList: true, subtree: true, characterData: true
      });
      /* Belt and braces: any interaction inside the options re-checks. */
      ['change', 'click', 'input'].forEach(function (evt) {
        document.addEventListener(evt, function (e) {
          if (e.target && e.target.closest && e.target.closest('.gpo-app')) again();
        }, true);
      });
    });
  }

  function waitForGlobo(tries) {
    if (document.querySelector('[gpo-data-variant-id]')) return start();
    if (tries <= 0) return;
    setTimeout(function () { waitForGlobo(tries - 1); }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForGlobo(30); });
  } else {
    waitForGlobo(30);
  }
})();
